'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — BFSI complaint & fraud operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Complaint & fraud pulse',
  kpis: [
    { val: '1,284', lbl: 'Live mentions', live: true },
    { val: '86', lbl: 'Open escalations' },
    { val: '3.8m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 38, tone: 'positive' },
    { lbl: 'Neutral', pct: 34, tone: 'neutral' },
    { lbl: 'Negative', pct: 28, tone: 'negative' },
  ],
  sla: { pct: 78, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'R', text: 'Unauthorised UPI debit from account', handle: '@rahul_b', tag: 'Fraud', tagLevel: 'high' },
    { letter: 'P', text: 'Wrong EMI charged on home loan', handle: '@priya_n', tag: 'Billing', tagLevel: 'med' },
    { letter: 'A', text: 'KYC pending 5 days, no update', handle: '@ankit_r', tag: 'KYC', tagLevel: 'med' },
    { letter: 'S', text: 'Moving my FD — worst service', handle: '@sneha_d', tag: 'Churn', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Fraud signal', sub: '12 accounts flagged for review' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Escalation → compliance in 2s' },
  ],
};

export default function BfsiHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('industries_bfsi.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('industries_bfsi.bfsi'),
      }}
      title={
        <>
          {t('industries_bfsi.from')}{' '}
          <span className="serif-accent italic">{t('industries_bfsi.complaint_signal_to_resolution')}</span>
          {' '}{t('industries_bfsi.the_bfsi_customer_experience_platfo')}{' '}
          <span className="serif-accent italic">{t('industries_bfsi.indias_banks_nbfcs_insurers')}</span>
        </>
      }
      lead={
        <>
          {t('industries_bfsi.an')} <span style={BLUE}>{t('industries_bfsi.rbi_ombudsman_complaint_escalation')}</span> {t('industries_bfsi.starts_as_a_single_unresolved_post')} <span style={BLUE}>{t('industries_bfsi.fraud_signal')}</span> {t('industries_bfsi.on_twitterx_becomes_a_depositor_pan')} <span style={DEEP}>{t('industries_bfsi.locobuzz_intercepts_both')}</span> {t('industries_bfsi.one_bfsi_cx_platform_signal_to_outc')}
          {' '}
          {t('industries_bfsi.agentic_ai_for_banking_that_acts_on')}
        </>
      }
      actions={
        <BookDemoButton label={t('industries_bfsi.see_it_in_action_book_a_bfsi_demo')} />
      }
      visual={<IndustryCommandCentre ariaLabel="BFSI complaint and fraud command centre" {...CC} />}
    />
  );
}
